export default "__VITE_ASSET__DnulBhI___"